import React from 'react';
import FilterBase from 'components/view/FilterBase';
import Dropdown from 'components/connectedForm/Dropdown';
import fieldMetaData from 'graphql/schema/fieldMetaData';

class FilterEnum extends FilterBase {
  constructor(props) {
    super(props);

    this.getBadgeText = this.getBadgeText.bind(this);
    this.getDescription = this.getDescription.bind(this);
    this.getQueryFilters = this.getQueryFilters.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.renderPopout = this.renderPopout.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
  }

  getInitialValues(props) {
    let initialValues = Object.assign({}, props);

    delete initialValues.label;
    delete initialValues.type;
    delete initialValues.fieldName;
    delete initialValues.onFilterUpdated;
    delete initialValues.position;
    delete initialValues.dispatch;
    delete initialValues.list;
    delete initialValues.initiallyOpen;

    return initialValues;
  }

  getBadgeText() {
    if (!this.committedValues.codes || this.committedValues.codes.length === 0) {
      return null;
    }
    return this.committedValues.codes.length;
  }

  getDescription() {
    if (!this.committedValues.codes) {
      return 'All';
    }

    let text = this.committedValues.codes.label;
    if (text === '') {
      return 'Unknown Codes';
    }
    return text;
  }

  getQueryFilters() {
    if (!this.committedValues.codes) {
      return null;
    }

    return [
      {
        fieldName: this.props.fieldName + (this.props.isEnum ? '' : '.id'),
        operation: 'EQUALS',
        value: this.committedValues.codes.value,
      },
    ];
  }

  getOptions() {
    if (this.props.enumValues) {
      return this.props.enumValues;
    }
    const fieldMeta = fieldMetaData[this.props.objectType];
    return fieldMeta.enumValues;
  }

  handleBlur() {}

  onChange(value) {
    let values = [];
    if (Array.isArray(value)) {
      values = value.map(opt => opt.value);
    }
    this.handleChange('codes', values);
  }

  renderDropdown(options) {
    return (
      <Dropdown
        id="codes"
        setInputRef={this.setInputRef}
        includeLabel={false}
        value={this.state.filterValues.codes}
        multi={true}
        inputCols={1}
        options={options}
        onChange={value => this.onChange(value)}
        onBlur={this.handleBlur}
      />
    );
  }

  renderPopout() {
    const options = this.getOptions();
    let dropdown = null;

    if (options) {
      dropdown = this.renderDropdown(options);
    }
    return <div style={{ padding: '4px 6px 0px 6px' }}>{dropdown}</div>;
  }
}

export default FilterEnum;
